/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, ref, computed, toRefs, watch } from '@vue/composition-api';
import { ChevronDownIcon, ChevronLeftIcon, CloseIcon } from 'tdesign-icons-vue';
import props from './props.js';
import Container from './base/Container.js';
import TImageViewerIcon from './base/ImageModalIcon.js';
import TImageViewerUtils from './base/ImageViewerUtils.js';
import TImageItem from './base/ImageItem.js';
import TImageViewerModal from './base/ImageViewerModal.js';
import { useVModel } from '../hooks/useVModel.js';
import useDefaultValue from '../hooks/useDefaultValue.js';
import { usePrefixClass } from '../hooks/useConfig.js';
import { renderTNodeJSX } from '../utils/render-tnode.js';
import { setTransform } from '../utils/helper.js';
import { useMirror, useScale, useRotate } from './hooks.js';
import { getOverlay, formatImages } from './utils.js';
import { EVENT_CODE } from './const.js';
import { Image } from '../image/index.js';
import 'vue';
import '../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../hooks/tnode.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../hooks/render-tnode.js';
import 'lodash/isObject';
import '../tooltip/index.js';
import '../tooltip/tooltip.js';
import '../_chunks/dep-1461d230.js';
import '../tooltip/props.js';
import '../popup/props.js';
import '../popup/popup.js';
import '@babel/runtime/helpers/typeof';
import '@popperjs/core';
import 'lodash/debounce';
import '../_common/js/utils/set-style.js';
import '../popup/container.js';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import '../utils/event.js';
import '../popup/utils.js';
import '../utils/map-props.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../tooltip/type.js';
import '../hooks/index.js';
import '../hooks/slots.js';
import 'lodash/isArray';
import '../hooks/useCommonClassName.js';
import '../config-provider/useConfig.js';
import '../hooks/useDestroyOnClose.js';
import '../hooks/useElementLazyRender.js';
import '../_common/js/utils/observe.js';
import '../hooks/useFormDisabled.js';
import '../hooks/useGlobalIcon.js';
import '../hooks/useLazyLoad.js';
import '../hooks/useResizeObserver.js';
import '../hooks/useVirtualScrollNew.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../hooks/useImagePreviewUrl.js';
import '../_common/js/upload/utils.js';
import '../_common/js/log/log.js';
import '../dialog/index.js';
import '../dialog/dialog.js';
import 'lodash/isNumber';
import 'lodash/throttle';
import '../button/index.js';
import '../button/button.js';
import '../loading/index.js';
import '../loading/directive.js';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../loading/plugin.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/helper.js';
import 'lodash/isNull';
import 'lodash/isUndefined';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../config.js';
import '../loading/type.js';
import '../button/props.js';
import '../utils/ripple.js';
import '../button/type.js';
import '../dialog/actions.js';
import '../dialog/props.js';
import '../dialog/stack.js';
import '../_common/js/utils/getScrollbarWidth.js';
import '../dialog/type.js';
import '../dialog/plugin.js';
import '../config-provider/config-provider.js';
import 'lodash/cloneDeep';
import '../image/image.js';
import 'lodash/omit';
import '../image/props.js';
import '../space/index.js';
import '../space/space.js';
import '../space/props.js';
import '../space/type.js';
import '../image/type.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _ImageViewer = defineComponent({
  name: "TImageViewer",
  props: _objectSpread({}, props),
  model: {
    prop: "visible",
    event: "change"
  },
  setup: function setup(props2, _ref) {
    var _props2$defaultIndex;
    var emit = _ref.emit;
    var classPrefix = usePrefixClass();
    var COMPONENT_NAME = usePrefixClass("image-viewer");
    var isExpand = ref(true);
    var showOverlayValue = computed(function () {
      return getOverlay(props2);
    });
    var _toRefs = toRefs(props2),
      index = _toRefs.index,
      visible = _toRefs.visible;
    var _useDefaultValue = useDefaultValue(index, (_props2$defaultIndex = props2.defaultIndex) !== null && _props2$defaultIndex !== void 0 ? _props2$defaultIndex : 0, props2.onIndexChange, "index", "index-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      indexValue = _useDefaultValue2[0],
      setIndexValue = _useDefaultValue2[1];
    var _useVModel = useVModel(visible, props2.defaultVisible, function () {}, "change", "visible"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      visibleValue = _useVModel2[0],
      setVisibleValue = _useVModel2[1];
    var rootClass = computed(function () {
      return ["".concat(COMPONENT_NAME.value)];
    });
    var wrapClass = computed(function () {
      return [COMPONENT_NAME.value, "".concat(COMPONENT_NAME.value, "-preview-image"), _defineProperty({}, "".concat(classPrefix.value, "-is-hide"), !visibleValue.value)];
    });
    var headerClass = computed(function () {
      return ["".concat(classPrefix.value, "-image-viewer__modal-header"), _defineProperty({}, "".concat(classPrefix.value, "-is-show"), isExpand.value)];
    });
    var zIndexValue = computed(function () {
      var _props2$zIndex;
      return (_props2$zIndex = props2.zIndex) !== null && _props2$zIndex !== void 0 ? _props2$zIndex : 2600;
    });
    var toggleExpand = function toggleExpand() {
      isExpand.value = !isExpand.value;
    };
    var _useMirror = useMirror(),
      mirror = _useMirror.mirror,
      onMirror = _useMirror.onMirror,
      resetMirror = _useMirror.resetMirror;
    var _useScale = useScale(props2.imageScale),
      scale = _useScale.scale,
      onZoomIn = _useScale.onZoomIn,
      onZoomOut = _useScale.onZoomOut,
      resetScale = _useScale.resetScale;
    var _useRotate = useRotate(),
      rotate = _useRotate.rotate,
      onRotate = _useRotate.onRotate,
      resetRotate = _useRotate.resetRotate;
    var onRest = function onRest() {
      resetMirror();
      resetScale();
      resetRotate();
    };
    var imagesList = computed(function () {
      return formatImages(props2.images);
    });
    var currentImage = computed(function () {
      var _imagesList$value$ind;
      return (_imagesList$value$ind = imagesList.value[indexValue.value]) !== null && _imagesList$value$ind !== void 0 ? _imagesList$value$ind : {
        mainImage: ""
      };
    });
    var prevImage = function prevImage() {
      var newIndex = indexValue.value - 1;
      onRest();
      setIndexValue(newIndex < 0 ? 0 : newIndex, {
        trigger: "prev"
      });
    };
    var nextImage = function nextImage() {
      var newIndex = indexValue.value + 1;
      onRest();
      setIndexValue(newIndex >= imagesList.value.length ? indexValue.value : newIndex, {
        trigger: "next"
      });
    };
    var onImgClick = function onImgClick(i) {
      setIndexValue(i, {
        trigger: "current"
      });
    };
    var openHandler = function openHandler() {
      setVisibleValue(true);
    };
    var onCloseHandle = function onCloseHandle(ctx) {
      var _props2$onClose;
      setVisibleValue(false);
      (_props2$onClose = props2.onClose) === null || _props2$onClose === void 0 || _props2$onClose.call(props2, ctx);
      emit("close", ctx);
    };
    var closeBtnAction = function closeBtnAction(e) {
      onCloseHandle({
        e: e,
        trigger: "close-btn"
      });
    };
    var clickOverlayHandler = function clickOverlayHandler(e) {
      if (props2.closeOnOverlay) {
        onCloseHandle({
          e: e,
          trigger: "overlay"
        });
      }
    };
    var keydownHandler = function keydownHandler(e) {
      switch (e.code) {
        case EVENT_CODE.left:
          prevImage();
          break;
        case EVENT_CODE.right:
          nextImage();
          break;
        case EVENT_CODE.up:
          onZoomIn();
          break;
        case EVENT_CODE.down:
          onZoomOut();
          break;
        case EVENT_CODE.esc:
          onCloseHandle({
            e: e,
            trigger: "esc"
          });
          break;
        default:
          break;
      }
    };
    var containerRef = ref();
    var mountContent = function mountContent() {
      if (containerRef) {
        containerRef.value.mountContent();
      }
    };
    var unmountContent = function unmountContent() {
      if (containerRef) {
        containerRef.value.unmountContent();
      }
    };
    watch(function () {
      return visibleValue.value;
    }, function (val) {
      if (val) {
        onRest();
        window.addEventListener("keydown", keydownHandler);
        mountContent();
        return;
      }
      window.removeEventListener("keydown", keydownHandler);
      unmountContent();
    });
    var onWheel = function onWheel(e) {
      e.preventDefault();
      var deltaY = e.deltaY,
        ctrlKey = e.ctrlKey;
      if (ctrlKey) {
        return deltaY > 0 ? onZoomOut() : onZoomIn();
      }
      deltaY > 0 ? onZoomIn() : onZoomOut();
    };
    var transStyle = computed(function () {
      return setTransform("translateX(calc(-".concat(indexValue.value, " * (40px / 9 * 16 + 4px)))"));
    });
    var isMultipleImg = computed(function () {
      return imagesList.value.length > 1;
    });
    return {
      COMPONENT_NAME: COMPONENT_NAME,
      rootClass: rootClass,
      classPrefix: classPrefix,
      prevImage: prevImage,
      nextImage: nextImage,
      zIndexValue: zIndexValue,
      visibleValue: visibleValue,
      indexValue: indexValue,
      imagesList: imagesList,
      showOverlayValue: showOverlayValue,
      wrapClass: wrapClass,
      rotate: rotate,
      mirror: mirror,
      currentImage: currentImage,
      onRotate: onRotate,
      onZoomIn: onZoomIn,
      onZoomOut: onZoomOut,
      onMirror: onMirror,
      onRest: onRest,
      openHandler: openHandler,
      onCloseHandle: onCloseHandle,
      onWheel: onWheel,
      clickOverlayHandler: clickOverlayHandler,
      headerClass: headerClass,
      toggleExpand: toggleExpand,
      transStyle: transStyle,
      onImgClick: onImgClick,
      closeBtnAction: closeBtnAction,
      scale: scale,
      isMultipleImg: isMultipleImg,
      containerRef: containerRef
    };
  },
  methods: {
    renderHeader: function renderHeader() {
      var _this = this;
      var h = this.$createElement;
      return h("div", {
        "class": this.headerClass
      }, [h(TImageViewerIcon, {
        "attrs": {
          "icon": function icon() {
            return h(ChevronDownIcon);
          },
          "clickHandler": this.toggleExpand
        },
        "class": "".concat(this.COMPONENT_NAME, "__header-pre-bt")
      }), h("div", {
        "class": "".concat(this.COMPONENT_NAME, "__header-prev")
      }, [h("div", {
        "class": "".concat(this.COMPONENT_NAME, "__header-trans"),
        "style": this.transStyle
      }, [this.imagesList.map(function (image, index) {
        return h("div", {
          "key": index,
          "class": ["".concat(_this.COMPONENT_NAME, "__header-box"), _defineProperty({}, "".concat(_this.classPrefix, "-is-active"), index === _this.indexValue)]
        }, [h(Image, {
          "attrs": {
            "alt": "",
            "src": image.thumbnail || image.mainImage
          },
          "class": "".concat(_this.COMPONENT_NAME, "__header-img"),
          "on": {
            "click": function click() {
              return _this.onImgClick(index);
            }
          }
        })]);
      })])])]);
    },
    renderNavigationArrow: function renderNavigationArrow(type) {
      var h = this.$createElement;
      var rotateDeg = type === "prev" ? 0 : 180;
      var _icon = renderTNodeJSX(this, "navigationArrow", h(ChevronLeftIcon, {
        "style": setTransform("rotate(".concat(rotateDeg, "deg)")),
        "attrs": {
          "size": "24px"
        }
      }));
      return h(TImageViewerIcon, {
        "class": "".concat(this.COMPONENT_NAME, "__modal-").concat(type, "-bt"),
        "attrs": {
          "clickHandler": type === "prev" ? this.prevImage : this.nextImage,
          "icon": function icon() {
            return _icon;
          }
        }
      });
    },
    renderModal: function renderModal() {
      var h = this.$createElement;
      return h(TImageViewerModal, {
        "attrs": {
          "zIndex": this.zIndexValue,
          "visible": this.visibleValue,
          "index": this.indexValue,
          "images": this.imagesList,
          "scale": this.scale,
          "rotate": this.rotate,
          "mirror": this.mirror,
          "currentImage": this.currentImage,
          "rotateHandler": this.onRotate,
          "zoomInHandler": this.onZoomIn,
          "zoomOutHandler": this.onZoomOut,
          "mirrorHandler": this.onMirror,
          "resetHandler": this.onRest,
          "closeHandler": this.onCloseHandle,
          "draggable": this.draggable,
          "showOverlay": this.showOverlayValue,
          "closeBtn": this.closeBtn
        }
      });
    },
    renderCloseBtn: function renderCloseBtn() {
      var h = this.$createElement;
      if (this.closeBtn === false) {
        return;
      }
      return h("div", {
        "class": ["".concat(this.COMPONENT_NAME, "__modal-icon"), "".concat(this.COMPONENT_NAME, "__modal-close-bt")],
        "on": {
          "click": this.closeBtnAction
        }
      }, [renderTNodeJSX(this, "closeBtn", h(CloseIcon, {
        "attrs": {
          "size": "24px"
        }
      }))]);
    },
    renderViewer: function renderViewer() {
      var h = this.$createElement;
      return h("div", {
        "class": this.wrapClass,
        "style": {
          zIndex: this.zIndexValue
        },
        "on": {
          "wheel": this.onWheel
        }
      }, [!!this.showOverlayValue && h("div", {
        "class": "".concat(this.COMPONENT_NAME, "__modal-mask"),
        "on": {
          "click": this.clickOverlayHandler
        }
      }), this.isMultipleImg && this.renderHeader(), this.isMultipleImg && this.renderNavigationArrow("prev"), this.isMultipleImg && this.renderNavigationArrow("next"), this.isMultipleImg && h("div", {
        "class": "".concat(this.COMPONENT_NAME, "__modal-index")
      }, [renderTNodeJSX(this, "title"), "".concat(this.indexValue + 1, "/").concat(this.imagesList.length)]), this.renderCloseBtn(), h(TImageViewerUtils, {
        "attrs": {
          "zoomInHandler": this.onZoomIn,
          "zoomOutHandler": this.onZoomOut,
          "mirrorHandler": this.onMirror,
          "resetHandler": this.onRest,
          "rotateHandler": this.onRotate,
          "scale": this.scale,
          "currentImage": this.currentImage
        }
      }), h(TImageItem, {
        "attrs": {
          "scale": this.scale,
          "rotate": this.rotate,
          "mirror": this.mirror,
          "src": this.currentImage.mainImage,
          "placementSrc": this.currentImage.thumbnail
        }
      })]);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(Container, {
      "ref": "containerRef",
      "attrs": {
        "mode": this.mode,
        "renderModal": this.renderModal,
        "renderViewer": this.renderViewer
      }
    }, [renderTNodeJSX(this, "trigger", {
      params: {
        open: this.openHandler
      }
    })]);
  }
});

export { _ImageViewer as default };
//# sourceMappingURL=image-viewer.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/image-viewer/image-viewer.js
// module id = null
// module chunks = 